<template lang="pug">
  footer.footer
    .container
      .content.has-text-centered
        router-link(to="/" exact class="logo")
          img(src='@/assets/logo-terna.png', alt='Terna', width='103', height='25')
      .content.has-text-centered(v-html="settings.footer")
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'TheFooter',
  computed: {
    ...mapGetters([
      'settings'
    ])
  },
  data () {
    return {
      placeholder: false
    }
  },
  mounted () {
    console.log('route: ', this.$route.name)
  }
}
</script>
<style lang="scss" scoped>
.footer {
  padding: 0rem 1.5rem 2rem 0rem;
  background-color: transparent;
}
.footer p {
    margin-bottom: 0em;
}
.logo {
  display: block;
  margin: 2em 0;
}
.menu {
  a {
    margin: 0 1em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TheFooter.vue